import React from 'react';
import lineLogo from '../../../../../assets/line.png';

export const lineIcon = props => {
  return <img src={lineLogo} width="18" height="18" alt="" aria-hidden="true" {...props} />;
};
